const apiURL = process.env.REACT_APP_BACKEND_URL;

export { apiURL };
